export default __webpack_public_path__ + "static/media/Image(1).ecd831d0.png";